










import { Vue, Component } from 'vue-property-decorator';
import ContratoProveedor from '@/pantallas/ContratoProveedor/ContratoProveedor.vue';

@Component({
  components: { ContratoProveedor },
})
export default class ContratoProveedorPantalla extends Vue {}
